<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0040_certificate_information_linked_devices</div>
        <app-header>esma</app-header>
        <div :class="'container ' +pageContainerSize">
          <title-and-search title="紐付機器一覧"></title-and-search>
          <div class="col-xs-4">
           <button class="btn btn-primary" style="min-width:100px;width: 25%;float: left;margin-left: 10px;" @click="backToCertificateDetail">＜　戻る</button>
          </div>
         <br>
         <br>
         <br>
          <search-control
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 230px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
            <button :disabled="localCertificateSeqId < 0" class="btn btn-primary" style="min-width:100px;width:100px;float: right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="unlinkItem"  >紐付解除</button>
            <button :disabled="disableSelectNew" class="btn btn-primary" style="min-width:100px;width:100px;float: right;margin-left: 10px;background:#92D050;border-color:#92D050;" @click="linkNewItem" >追加</button>
            <br>
            <br>
          </div>
        </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_device_embedded_information';
import { utils } from '@/libs/utils';
import _debug from 'debug';
  var mdebug = _debug('esma:certificate_information_linked_devices');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      local_certificate_seq_id:-1,
      page_mode:"list",
      api_name:"certificate_information_linked_devices",
      page_acl: acl.generic,
      device_embedded_detail_seq_id:-1,
      detail_page:"page_0010_device_embedded_information_detail",
      disable_select_new:true
    };
  },
  computed: {
    localCertificateSeqId:{
      get(){
        return this.local_certificate_seq_id;
      },
      set(v){
        this.local_certificate_seq_id = v;
      }
    },
   disableSelectNew :{
      get(){
        return this.disable_select_new;
      },
      set(v){
        this.disable_select_new = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },

    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.approval_status, {}),
        utils.extend(fields.device_control_number, {}),
        utils.extend(fields.registration_date, {}),
        utils.extend(fields.computer_name, {}),
        utils.extend(fields.equipment_in_charge_department, {}),
        utils.extend(fields.equipment_in_charge_team, {}),
        utils.extend(fields.equipment_in_charge_classification, {}),
        utils.extend(fields.equipment_in_charge_system, {}),
        utils.extend(fields.installation_department, {}),
        utils.extend(fields.installation_team, {}),
        utils.extend(fields.user_name, {}),
        utils.extend(fields.item_number, {}),
        utils.extend(fields.management_person_name, {}),
      ];
    }
  },
  methods: {
    unlinkItem(){

      var obj = this.selectedRowArr.map((r)=>{
        return {
          device_embedded_detail_seq_id:r.device_embedded_detail_seq_id
        }
      });

      // Support single selection.
      if(!(obj && obj.length > 0) && this.$route.params.req_ad_seq_id.length > 0){
        obj = [{
          device_embedded_detail_seq_id:this.device_embedded_detail_seq_id
          }]
      };


      this.$ajax.post("/certificate_information_linked_devices/unlink_device/", {arr:obj}, (err, data) => {
          if(err){
            this.$notify({
              title: 'データの紐付解除に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }else{
            this.$notify({
              title: '紐付されていません。', 
              type: 'sucess',
              duration: 1000
            });
          }
          //TODO: Need to refresh the data to remove the removed item
          this.localRefreshDeletedRow();
      });

      
    },
    getAssociatedDeviceInfo(){
      this.$ajax.post("/associated_device/get/"+this.$route.params.req_ad_seq_id, {}, (err, result) => {
          if(err){
            this.$notify({
              title: 'ソフトウェア情報の読込に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }else{
            if(result.data.license == "-"){
              this.disableSelectNew = false;
            }else{
              var the_number_of_remaining = 0;
              if(result  && result.data  && isNaN(result.data.the_number_of_remaining) == false ){
                the_number_of_remaining = parseInt(result.data.the_number_of_remaining)
              }
              if(the_number_of_remaining <= 0){
                this.disableSelectNew = true;
              }else{
                this.disableSelectNew = false;
              }
            }
          }
      });
    },
    localRefreshDeletedRow(){
      this.countRows("localRefreshDeletedRow");
      this.gridOptions.api.purgeInfiniteCache();
      // var selectedData = this.gridOptions.api.getSelectedRows();
      
      // var res = this.gridOptions.api.updateRowData({remove: selectedData});
      // console.log("localRefreshDeletedRow ",{selectedData,res})
      // // var removed = _.remove(this.row_data,{seq_id:id})
      // // var found = _.find(this.row_data,{seq_id:id})

      // // debug_pageCommon("refreshDeletedRow removed", removed,"found",found, "res",res)

      // this.gridOptions.api.refreshView();
    },
    linkNewItem(){
      return this.$router.push("/certificate_information_linked_devices/select/" + this.$route.params.req_ad_seq_id + "/" + this.$route.params.cert_id );
    },
    backToCertificateDetail(){
      return this.$router.push("/certificate_information/" + this.$route.params.cert_id );;
    },
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: "page_0010_device_embedded_information_detail", params: {  seq_id:data.seq_id} });
    },
    addNew(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:"new"} });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:false})
    },
    onRowSelected(ev){
      this.selected_row = ev.node.data.seq_id;
      this.device_embedded_detail_seq_id =  ev.node.data.device_embedded_detail_seq_id;
      this.localCertificateSeqId = ev.node.data.certificate_seq_id;
    }
  },
  mounted() {
    this.addHtmlClass(document.body,'blue_bg')
    this.gridOptions.api.sizeColumnsToFit();
    this.getAssociatedDeviceInfo();
  },
  beforeDestroy() {
    this.removeHtmlClass(document.body,'blue_bg')
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.api_request_options = {seq_id:this.$route.params.req_ad_seq_id};
    this.initDatasource();
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0040_certificate_information_linked_devices.vue?b30e650c